import React, { useEffect, useState } from "react";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";

import { getTrans as t } from "../../../Localization/translations";
import ButtonLoading from "../../../components/Loder/buttonLoading";
import { API } from "../../../backend";
import authHeader from "../../../services/auth-header";

const UserPermissionsTable = () => {
  const [permissions, setPermissions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [btnloding, setBtnLoading] = useState(false);

  const localtion = useLocation();
  const id = localtion?.state;

  useEffect(() => {
    axios
      .get(API + `get_available_permissions/${id}`, { headers: authHeader() })
      .then((response) => {
        const groupedPermissions = groupPermissionsByCodename(
          response.data.permissions
        );
        setPermissions(groupedPermissions);
        setLoading(false);
      })
     
  }, []);

  const groupPermissionsByCodename = (permissions) => {
    const groupedPermissions = {};

    permissions.forEach((permission) => {
      const codename = permission.codename;
      const name = permission.name;

      if (codename === "can_view_reports") {
        if (!groupedPermissions["Reports"]) {
          groupedPermissions["Reports"] = [];
        }
        groupedPermissions["Reports"].push({
          id: permission.id,
          name: name,
          selected: permission.selected,
        });
      } else if (codename === "can_view_dashboard") {
        if (!groupedPermissions["Dashboard"]) {
          groupedPermissions["Dashboard"] = [];
        }
        groupedPermissions["Dashboard"].push({
          id: permission.id,
          name: name,
          selected: permission.selected,
        });
      } else if (codename === "can_view_payment") {
        if (!groupedPermissions["Payment"]) {
          groupedPermissions["Payment"] = [];
        }
        groupedPermissions["Payment"].push({
          id: permission.id,
          name: name,
          selected: permission.selected,
        });
      } else {
        const baseName = getBaseNameFromCodename(codename);
        if (!groupedPermissions[baseName]) {
          groupedPermissions[baseName] = [];
        }
        groupedPermissions[baseName].push({
          id: permission.id,
          name: name,
          selected: permission.selected,
        });
      }
    });

    return groupedPermissions;
  };


  const getBaseNameFromCodename = (codename) => {
    const parts = codename.split("_");
    if (parts.length >= 2) {
      return parts[1];
    }
    return "";
  };

  const getuserpermssion = () => {
    axios
      .get(API + "user/permissions/", { headers: authHeader() })
      .then((response) => {
        const userPermissions = response.data;
        localStorage.setItem("permissions", userPermissions);
      })
  };

  const handleCheckboxChange = (baseName, action, permission) => {
    permission.selected = !permission.selected;

    setPermissions((prevPermissions) => ({
      ...prevPermissions,
      [baseName]: prevPermissions[baseName].map((p) =>
        p.id === permission.id ? permission : p
      ),
    }));
  };

  let navigate = useNavigate();

  const handleSavePermissions = () => {
    setBtnLoading(true);
    const selectedPermissionIds = [];

    // Iterate through all permissions
    Object.keys(permissions).forEach((baseName) => {
      permissions[baseName].forEach((permission) => {
        if (permission.selected) {
          selectedPermissionIds.push(permission.id);
        }
      });
    });

    // Send a request to update user permissions via the Django API
    axios
      .post(
        API + `update_user_permissions/${id}/`,
        { permission_ids: selectedPermissionIds },
        { headers: authHeader() }
      )
      .then((response) => {
        toast.success(`Permissions updated successfully`, {
          position: "top-right",
          autoClose: 1000,
          hideProgressBar: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        getuserpermssion();
        setTimeout(() => {
          navigate("/user");
        }, 2000);
        setBtnLoading(false);
      })
      
    setBtnLoading(false).catch((error) => {
      console.error("Error updating permissions:", error);
    });
  };
  const filteredPermissionBaseNames = Object.keys(permissions).filter(
    (baseName) =>
      ![
        "globalpermission",
        "chatbot",
        "userfiled",
        "customuser",
        "partynotificationsettings",
        "partycontact",
        "partyaddress",
        "paymentschedule",
        "contractassets",
        "companyuser",
        "paymentschedulesloan",
        "amortizationschedule",
        "amortschedules",
        "assetreturn",
        "paymentdetails",
        "paymentdailyinterest",
        "feedefination",
        "contenttype",
        "companysettings",
        "subscription",
        "package",
        "company",
        "category",
        "searchhistory",
        "state",
        "country",
        "logentry",
        "invoicelines",
        "tokenproxy",
        "token",
        "user",
        "permission",
        "group",
        "transaction",
        "periods",
        "legalentities",
        "glenteries",
        "amountobjects",
        "receiptapplication",
        "supportticket",
        "ratecardlines",
        "subcategory",
        "session",
        "blacklistedtoken",
        "outstandingtoken",
      ].includes(baseName)
  );
  return (
    <div className="container-fluid">
      {loading ? (
        <p>Loading permissions...</p>
      ) : (
        <div>
          <ToastContainer />
          <div className="header pb-0 pt-3">
            <div className="row">
              <div className="col-lg-6 col-7">
                <h6 className="tc">{"User Permissions"}</h6>
              </div>
            </div>
          </div>
          <div className="card">
            <div className="body">
              <div className="table-responsive">
                <table className="table table-striped align-items-center mb-0">
                  <thead>
                    <tr>
                      <th className="text-uppercase  text-left text-secondary text-xxs font-weight-bolder opacity-7 ps-2">
                        Application
                      </th>
                      <th className="text-uppercase  text-left text-secondary text-xxs font-weight-bolder opacity-7 ps-2">
                        Create
                      </th>
                      <th className="text-uppercase  text-left text-secondary text-xxs font-weight-bolder opacity-7 ps-2">
                        Change
                      </th>
                      <th className="text-uppercase  text-left text-secondary text-xxs font-weight-bolder opacity-7 ps-2">
                        Delete
                      </th>
                      <th className="text-uppercase  text-left text-secondary text-xxs font-weight-bolder opacity-7 ps-2">
                        view
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredPermissionBaseNames.map((baseName) => (
                      <tr key={baseName}>
                        <td className="text-left">
                          <>
                            <div className="d-xl-none tc">{"Application"} </div>
                            <div>{t(baseName)}</div>
                          </>
                        </td>
                        <td className="text-left">
                          {permissions[baseName] && permissions[baseName][0] ? (
                            <input
                              type="checkbox"
                              checked={permissions[baseName][0].selected}
                              onChange={() =>
                                handleCheckboxChange(baseName, "add", permissions[baseName][0])
                              }
                            />
                          ) : null}
                        </td>
                        <td className="text-left">
                          {permissions[baseName] && permissions[baseName][1] ? (
                            <input
                              type="checkbox"
                              checked={permissions[baseName][1].selected}
                              onChange={() =>
                                handleCheckboxChange(baseName, "change", permissions[baseName][1])
                              }
                            />
                          ) : null}
                        </td>
                        <td className="text-left">
                          {permissions[baseName] && permissions[baseName][2] ? (
                            <input
                              type="checkbox"
                              checked={
                                permissions[baseName][2].selected ||
                                ["can_view_reports", "can_view_dashboard", "can_view_payment"].includes(baseName)
                              }
                              onChange={() =>
                                handleCheckboxChange(baseName, "view", permissions[baseName][2])
                              }
                            />
                          ) : null}
                        </td>
                        <td className="text-left">
                          {permissions[baseName] && permissions[baseName][3] ? (
                            <input
                              type="checkbox"
                              checked={permissions[baseName][3].selected}
                              onChange={() =>
                                handleCheckboxChange(baseName, "delete", permissions[baseName][3])
                              }
                            />
                          ) : null}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <button
            className="btn btn-primary mb-0 mt-3"
            onClick={handleSavePermissions}
          >
            {btnloding === false ? t("Update") : <ButtonLoading />}
          </button>
        </div>
      )}
    </div>
  );
};

export default UserPermissionsTable;
